/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const ReferenceFilter = core.serialization.object({
    refField: core.serialization.string(),
    recordField: core.serialization.string(),
});
